import reduxThunk from 'redux-thunk';
import reduxHotjar from 'redux-hotjar';

import createMetricsMiddleware from './createMetricsMiddleware';
import { metricsIsEnabled } from 'src/config';

const staticMiddleware = [
  reduxHotjar(),
  reduxThunk,
  ...(metricsIsEnabled ? [createMetricsMiddleware()] : []),
];

export default () => {
  return [...staticMiddleware];
};
